module.exports = require('./AppCardCollectionView');
